module.exports = require('./AppCardCollectionView');
